import { render, staticRenderFns } from "./DetailEditAddress.vue?vue&type=template&id=26ae6b9e&scoped=true"
import script from "./DetailEditAddress.vue?vue&type=script&lang=js"
export * from "./DetailEditAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26ae6b9e",
  null
  
)

export default component.exports